import {atom} from "recoil";

/**
 * 휴가 폰번호 텍스트 필드
 * @type {(param: SerializableParam) => RecoilState<{NO: string, keyName: *, category: string}>}
 */
export const vacationPhoneValueAtom = atom({
    key: "vacationPhoneValueAtom",
    default: ""
})